import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/backend/agent/video/getList',
        method: 'post',
        data: data
    })
}
export function createUpdate(data) {
    return request({
        url: '/backend/agent/video/createUpdate',
        method: 'post',
        data: data
    })
}
export function getDetail(data) {
    return request({
        url: '/backend/agent/video/getDetail',
        method: 'post',
        data: data
    })
}
export function del(data) {
    return request({
        url: '/backend/agent/video/delete',
        method: 'post',
        data: data
    })
}
export function updateSort(data) {
    return request({
        url: '/backend/agent/video/updateSort',
        method: 'post',
        data: data
    })
}

export function updateStatus(data) {
    return request({
        url: '/backend/agent/video/updateStatus',
        method: 'post',
        data: data
    })
}